import { DrawerContentConfig, StyleObj } from '../../../@types';
import { ListItem, ListItemButton, ListItemIcon, Typography, List } from '@mui/material';
import { useNavigate } from 'react-router';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Divider from '@mui/material/Divider';
import SidebarAccordion from '../../molecules/SidebarAccordion';
import { getAccountDrawerConfig } from '../../../config/accountDrawer';
import useLocalization from '../../../hooks/useLocalization';
import useProductAvailability from '../../../hooks/useProductAvailability';
import { useKycVerificationEnabled } from '../../../hooks/components/useKycVerificationAccountSection';
import { useSkin } from '../../../contexts/SkinContext';
import { Theme } from '@mui/material/styles';

const styles: StyleObj = {
  listItem: {
    p: 0,
    ':hover': {
      backgroundColor: (theme: Theme) => theme.palette.primary.main,
    },
    '& .MuiButtonBase-root': {
      px: 3,
      py: 2,
    },
    '& .MuiSvgIcon-root': {
      fill: (theme: Theme) => theme.palette.text.primary,
    },
  },
  listItemButton: {
    '& .MuiListItemIcon-root': {
      minWidth: '36px',
    },
  },
  divider: {
    borderColor: (theme: Theme) => theme.palette.primary[500],
    mb: 1,
    mx: 3,
  },
};

const AccountDrawerContent = () => {
  const navigate = useNavigate();
  const { t } = useLocalization();
  const { skin } = useSkin();
  const { isCasinoOnlyProduct, isSportsbookOnlyProduct } = useProductAvailability();
  const includeVerification = useKycVerificationEnabled();

  const ACCOUNT_DRAWER_CONFIG = getAccountDrawerConfig(t, skin, {
    includeVerification,
    isCasinoOnlyProduct,
    isSportsbookOnlyProduct,
  });

  return (
    <List>
      <ListItem sx={styles.listItem}>
        <ListItemButton disableRipple sx={styles.listItemButton} onClick={() => navigate('/my-account')} disableGutters>
          <ListItemIcon>
            <AccountCircleIcon />
          </ListItemIcon>
          <Typography variant='h3'>{t('myAccount')}</Typography>
        </ListItemButton>
      </ListItem>
      <Divider variant='middle' component='li' sx={styles.divider} />
      {ACCOUNT_DRAWER_CONFIG.map((item: DrawerContentConfig) => (
        <SidebarAccordion item={item} navigateTo={navigate} key={`account-sidebar-${item.id}`} />
      ))}
    </List>
  );
};

export default AccountDrawerContent;
